export const initialAbility = [
  {
    action: 'VISUALIZAR',
    subject: 'AUTH',
  }
]

export const _ = undefined
